/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RenditionsControllerFindOneQueryResponse, RenditionsControllerFindOnePathParams, RenditionsControllerFindOneQueryParams, RenditionsControllerFindOne400, RenditionsControllerFindOne401, RenditionsControllerFindOne403, RenditionsControllerFindOne404 } from "../../models/documentRenditionsController/RenditionsControllerFindOne";

function getRenditionsControllerFindOneUrl(documentId: RenditionsControllerFindOnePathParams["documentId"], renditionId: RenditionsControllerFindOnePathParams["renditionId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${documentId}/renditions/${renditionId}` as const }  
  return res
}

/**
 * @description Returns a specific rendition by its ID
 * @summary Get a specific rendition
 * {@link /api/v1/documents/:documentId/renditions/:renditionId}
 */
export async function renditionsControllerFindOne(documentId: RenditionsControllerFindOnePathParams["documentId"], renditionId: RenditionsControllerFindOnePathParams["renditionId"], params?: RenditionsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RenditionsControllerFindOneQueryResponse, ResponseErrorConfig<RenditionsControllerFindOne400 | RenditionsControllerFindOne401 | RenditionsControllerFindOne403 | RenditionsControllerFindOne404>, unknown>({ method : "GET", url : getRenditionsControllerFindOneUrl(documentId, renditionId).url.toString(), params, ... requestConfig })  
  return res.data
}